import { render } from "./Stat.vue?vue&type=template&id=8d09f5ba&ts=true"
import script from "./Stat.vue?vue&type=script&lang=ts"
export * from "./Stat.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__